// extracted by mini-css-extract-plugin
export default {"title":"tagPage-module--title--2aKQM"};